import axios from 'axios';
import { setupSessionMiddleware } from '../Middleware/sessionAuth';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL?.concat('/api') || '/api';

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

setupSessionMiddleware(api);

export default api;

